function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ii_18_22572)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 5.04358,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint0_linear_18_22572)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 5.04358,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint1_linear_18_22572)"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 5.04358,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint2_radial_18_22572)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_ii_18_22572)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 8.91736,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint3_linear_18_22572)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 8.91736,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint4_linear_18_22572)"
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 8.91736,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint5_radial_18_22572)"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_ii_18_22572)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.4054 11.0083C7.6322 11.0083 7.00537 11.6351 7.00537 12.4083V12.9452H14.0045V12.4083C14.0045 11.6351 13.3777 11.0083 12.6046 11.0083H8.4054Z",
  fill: "url(#paint6_linear_18_22572)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_ii_18_22572)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.0642 6.98047C13.291 6.98047 12.6642 7.60727 12.6642 8.38047V8.91735H19.6633V8.38047C19.6633 7.60727 19.0366 6.98047 18.2634 6.98047H14.0642Z",
  fill: "url(#paint7_linear_18_22572)"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_ii_18_22572)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.3995 3.10669C18.6263 3.10669 17.9995 3.73349 17.9995 4.50669V5.04357H24.9986V4.50669C24.9986 3.73349 24.3718 3.10669 23.5986 3.10669H19.3995Z",
  fill: "url(#paint8_linear_18_22572)"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_ii_18_22572)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 12.9452,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint9_linear_18_22572)"
}));

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 2.04565,
  y: 12.9452,
  width: 27.9086,
  height: 17.0137,
  rx: 2.5,
  fill: "url(#paint10_radial_18_22572)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ii_18_22572",
  x: 1.74565,
  y: 5.04358,
  width: 28.2086,
  height: 17.4137,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.890196 0 0 0 0 0.290196 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_22572"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.298039 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_22572",
  result: "effect2_innerShadow_18_22572"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_ii_18_22572",
  x: 1.74565,
  y: 8.51736,
  width: 28.2086,
  height: 17.8137,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.956863 0 0 0 0 0.6 0 0 0 0 0.407843 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_22572"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.890196 0 0 0 0 0.290196 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_22572",
  result: "effect2_innerShadow_18_22572"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_ii_18_22572",
  x: 6.90537,
  y: 11.0083,
  width: 7.19915,
  height: 2.03689,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.25098 0 0 0 0 0.458824 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_22572"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.282353 0 0 0 0 0.262745 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_22572",
  result: "effect2_innerShadow_18_22572"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_ii_18_22572",
  x: 12.5642,
  y: 6.98047,
  width: 7.19915,
  height: 2.03689,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.298039 0 0 0 0 0.611765 0 0 0 0 0.85098 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_22572"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.270588 0 0 0 0 0.501961 0 0 0 0 0.768627 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_22572",
  result: "effect2_innerShadow_18_22572"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_ii_18_22572",
  x: 17.8995,
  y: 3.10669,
  width: 7.19915,
  height: 2.03689,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.34902 0 0 0 0 0.905882 0 0 0 0 0.603922 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_22572"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.239216 0 0 0 0 0.713726 0 0 0 0 0.411765 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_22572",
  result: "effect2_innerShadow_18_22572"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_ii_18_22572",
  x: 1.74565,
  y: 12.5452,
  width: 28.2086,
  height: 17.8137,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.956863 0 0 0 0 0.6 0 0 0 0 0.407843 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_22572"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.945098 0 0 0 0 0.317647 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_22572",
  result: "effect2_innerShadow_18_22572"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_22572",
  x1: 16,
  y1: 5.04358,
  x2: 16,
  y2: 9.55562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD650"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCD4A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_22572",
  x1: 16,
  y1: 9.64366,
  x2: 16,
  y2: 7.09051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBA48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBA48",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_18_22572",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.9543 5.49997) rotate(134.482) scale(2.2776 3.8525)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE857"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE857",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_18_22572",
  x1: 16,
  y1: 8.91736,
  x2: 16,
  y2: 25.9311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBA59"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_18_22572",
  x1: 16,
  y1: 14.3978,
  x2: 16,
  y2: 10.9203,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBA48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBA48",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_18_22572",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.9543 9.37375) rotate(134.482) scale(2.2776 3.8525)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE857"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE857",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_18_22572",
  x1: 10.5049,
  y1: 11.0083,
  x2: 10.5049,
  y2: 12.9452,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF416D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF3A66"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_22572",
  x1: 16.1638,
  y1: 6.98047,
  x2: 16.1638,
  y2: 8.91735,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4794D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4482CA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_18_22572",
  x1: 21.499,
  y1: 3.10669,
  x2: 21.499,
  y2: 5.04357,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4EDC8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#54C877"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_18_22572",
  x1: 16,
  y1: 12.9452,
  x2: 16,
  y2: 29.9589,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBA59"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_18_22572",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.9543 13.4016) rotate(134.482) scale(2.2776 3.8525)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE857"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE857",
  stopOpacity: 0
})));

function SvgCardIndexDividers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIndexDividers);
export default __webpack_public_path__ + "static/media/card_index_dividers.77af9e03.svg";
export { ForwardRef as ReactComponent };